import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Dropdown} from 'primereact/dropdown';
import {Column} from 'primereact/column';
import {Calendar} from 'primereact/calendar';
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import { DateFormetter } from '../../../shared/utility';
import {InputSwitch} from 'primereact/inputswitch';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import { DATATABLE_CONFIG, DROPDOWN_CONFIG, HOLIDAY_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS, scrollToTop } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

class HolidayMaster extends Component {
    state = {
        patternName: '',
        patternID: 'Pattern ID(Auto Generate)',
        holidayArray : [
            {
                name:'',    
                year:'',
                dates:'',
                isActive:true
            }
        ],
        holidayid :  null,
        type: 'add',
        touch : false,
        CreatedBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        CreatedDate : new Date(),
        UpdatedBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        UpdatedDate : new Date(),
        Years_list : []
    }


    delete  = (item) => {
        const updatedValue = [{ DeleteID : item}];
        this.props.dynamicDeleteProcess('holidays',updatedValue,'Holiday/GetHolidays');
    }

   
    editItem = (rowData,type) => {
         scrollToTop();
         let date = rowData.dates;
         let splitDate = date.split(",");
         let res = [];
         if(splitDate.length > 1){
            res[0] = new Date(splitDate[0]);
            res[1] = new Date(splitDate[splitDate.length-1]);
         }else{
            res[0] = new Date(splitDate[0]);
            res[1] = null
         }
        const newValue = [...this.state.holidayArray];
        newValue[0]['name'] = rowData.name;
        newValue[0]['year'] = rowData.year;
        newValue[0]['dates'] = res;
        newValue[0]['isActive'] = rowData.isActive;

    
        this.setState({type : type, holidayid : rowData.holidayid, patternName : rowData.description,patternID:rowData.patternID,
            
           holidayArray:newValue, CreatedBy: rowData.createdBy, CreatedDate:rowData.createdDate });
    }
  
  

    actionTemplate = (rowData, column) => {
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                <Button onClick={() => this.editItem(rowData,'edit')}  type="button" icon="pi pi-pencil" className="p-button-info" ></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                <Button onClick={() => this.editItem(rowData,'view')}  type="button" icon="pi pi-eye" className="p-button-secondary" ></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                <Button onClick={() => this.delete(rowData.holidayid)} icon="pi pi-trash"  className="p-button-danger"/>
            }
            </div>;
    }

   
    addHoliday = () => {    

     
        var val = Math.floor(1000 + Math.random() * 9000);
        let PatternId =  val;
        let PatternName = this.state.patternName;
 
        
        let holidayArray = this.state.holidayArray;

        if(holidayArray.length > 0 ){
    
            var err = false;
            var data = holidayArray.map(holiday=>{
                if(holiday.dates === '' || holiday.year === '' || holiday.name === ''){
                    this.growl.show({severity: 'error', summary: null, detail: 'Holiday name, year, dates are required'});
                    err = true
                    return '';
                }

                let date = holiday.dates;
                
                let showDate = '';
                let days = 1;
                if(date[1]!==null){
                    //showDate = DateFormetter(date[0],'dd/MM/yyyy')+','+DateFormetter(date[1],'dd/MM/yyyy');
                
                    let dates = []
                    const theDate = new Date(date[0])
                    while (theDate < date[1]) {
                      dates = [...dates, new Date(theDate)]
                      theDate.setDate(theDate.getDate() + 1)
                    }
                    dates = [...dates, date[1]]
                    let dateArray = []
                    let formateDate = dates.map(date => {

                        let dates = DateFormetter(date,'MM/dd/yyyy').toString();

                        dateArray.push(DateFormetter(date,'MM/dd/yyyy'));
                        //var datatoday = new Date(date);
                        // var datatodays = datatoday.setDate(new Date(datatoday).getDate() + 1);
                        // let todate = new Date(datatodays);
                        // let fDate = date.toISOString().slice(0, 10);
                        // fDate.setDate(fDate.getDate() + 1);
                        return dates;
                    })

                    days = dates.length;
                    showDate = dateArray.join(',')
                 
                }else{
                    showDate = DateFormetter(date[0],'MM/dd/yyyy')
                }


                let year = holiday.year;
                if(this.state.type === 'edit'){
                    return {
                            Holidayid : this.state.holidayid,
                            PatternId : PatternId,
                            Description : PatternName,
                            Name: holiday.name,            
                            Year: year,
                            Dates:showDate,
                            Holidaynum: days,
                            PublicHolidayType: '',
                            Publicholidaycalendar : '',
                            Guaranteed : true,
                            IsActive: holiday.isActive,
                            UpdatedBy: this.state.UpdatedBy,
                            UpdatedDate: this.state.UpdatedDate,
                            CreatedBy: this.state.CreatedBy,
                            CreatedDate: this.state.CreatedDate,

                     }
                }else{
                    return {
                            PatternId : PatternId,
                            Description : PatternName,
                            Name: holiday.name,            
                            Year: year,
                            Dates:showDate,
                            Holidaynum: days,
                            PublicHolidayType: '',
                            Publicholidaycalendar : '',
                            Guaranteed : true,
                            IsActive: holiday.isActive,
                            CreatedBy: this.state.CreatedBy,
                            CreatedDate: this.state.CreatedDate,
                     }
                }

            });

        }


        let valueData = {
            Holiday : data
        }
 
        if(err === false){
            this.props.processDynamicData('holidays',this.state.type,valueData,'Holiday/GetHolidays');
            setTimeout(() => {
                    this.resetData();
            }, 3000);
        }


    }


    changeKey = (e) => {
        let {name ,value} = e.target;
        this.setState({[name]:value,touch:true})
    }

    change = (e, index) => {
        e.preventDefault();
        const { name, value } = e.target;
        const newValue = [...this.state.holidayArray];
        newValue[index][name] = value;
        this.setState({holidayArray:newValue,touch:true})
    } 
  
    resetData = () => {
        const newValue = [...this.state.holidayArray];
        newValue[0]['name'] = '';
        newValue[0]['year'] = '';
        newValue[0]['dates'] = '';
        newValue[0]['isActive'] = true;
        this.setState({type : 'add', holidayid : null, patternName : '',patternID:'Auto Generate',
            
           holidayArray:newValue });


        this.setState({ name : '', date:''});
    }

    addFields = (e) => {
        e.preventDefault();
       
        let newValue = {
            name:'',    
            year:'',
            dates:'',
            isActive:true
        }
        let value = [...this.state.holidayArray, newValue];
        this.setState({holidayArray:value})
    }

    removeFields = (e, index) => {
        e.preventDefault();
     
        const updatedValue = this.state.holidayArray.filter((field, i) => {
            return index !== i;
        });
        
        this.setState({holidayArray:updatedValue})
    }


    componentDidMount(){        

        let currentYear = new Date().getFullYear();
        let value = [];
        value.push({label:currentYear,value:currentYear}); 
        for (var i = currentYear; i < (currentYear+15); i++) {     
            value.push({label:i+1,value:i+1});        
        }
        this.setState({Years_list : value});
        this.props.getMasterTableList('Holiday/GetHolidays');    
        this.getAccess = HASACCESS(HOLIDAY_SUBMENU_ID);
    }

    render() {   

        let addAccess = true;
        let editAccess = true;

        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}


        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        let tableData = []    
        if(this.props.tableLists && this.props.tableLists.length > 0){
            tableData = this.props.tableLists;
        }

        let isEnabled = (this.state.patternName !== '') && (this.state.touch === true);
       
     
        return (
            <div className="p-grid padding">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">

                    <div className="card card-w-title">
                        <h1>Holiday Master</h1>
               
                        <div className="p-grid">
                        
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <div className="mt1 ">
                                    <InputText className="width100" placeholder="Pattern Name" name="patternName" value={this.state.patternName} onChange={this.changeKey} />
                                    </div>                                
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <div className="mt1 ">
                                    <InputText className="width100" placeholder="Pattern ID" name="patternID" value={this.state.patternID} onChange={this.changeKey} readOnly/>
                                    </div>                                
                                </div>

                                { this.state.holidayArray.length > 0 && 
                                <>
                                {
                                this.state.holidayArray.map((holiday,index) => {
                                    return(
                                        <div className="p-col-12" key={index}> 
                                            <div className="card card-w-title">
                                                <div className="p-grid">
                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="mt1 ">
                                                        <InputText className="width100" placeholder="Holiday Name" name="name" value={holiday.name} onChange={(e) => this.change(e, index)} />
                                                        </div>                                
                                                    </div>

                                                    {/* <div className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="mt1 ">
                                                        <InputText className="width100" placeholder="Description" name="description" value={holiday.description} onChange={(e) => this.change(e, index)} />
                                                        </div>                                
                                                    </div> */}


                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="mt1 ">
                                                            <Calendar className="width100" placeholder="Date" name="dates" selectionMode="range" readOnlyInput={true} value={holiday.dates} onChange={(e) => this.change(e, index)} monthNavigator={true} yearNavigator={true} yearRange="2000:2050" />
                                                        </div>                                
                                                    </div>


                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="mt1 ">
                                                            <Dropdown className="p-lg-12" options={this.state.Years_list} value={holiday.year} 
                                                                onChange={(e) => this.change(e, index)} name="year" placeholder="Select Year" {...DROPDOWN_CONFIG} />
                                                        </div>                                
                                                    </div>

                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="mt1 ">
                                                        <InputSwitch checked={holiday.isActive} name="isActive" onChange={(e) => this.change(e, index)} />
                                                        </div>                                
                                                    </div>

                                                    <div className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="mt1 ">
                                                            {(index ===0) ? 
                                                                <Button onClick={(e) => this.addFields(e)} title={`Add Fields`} icon="pi pi-plus" className="p-button-success"/>

                                                            : null}

                                                            {(index!==0) ? 
                                                            <Button  onClick={(e) => this.removeFields(e, index)} title={`Remove Fields`} icon="pi pi-trash" className="p-button-danger"/>
                                                            : null}
                                                        </div>                                
                                                    </div>



                                                </div>
                                            </div>
                                        </div>


                                    )
                                })
                                    
                                }
                                
                                </>
                                }

                           
                            <div className="p-col-12 p-md-6 p-lg-12">
                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.addHoliday} reset={this.resetData}  to="" />
                            </div>
                     

         				 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                     
                            <DataTable ref={(el) => this.dt = el} value={tableData} globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >
                                <Column field="description" header="Patterns" />
                                <Column field="name" header="Name" />
                                <Column field="dates" header="Date"  />
                                <Column field="holidaynum" header="Days" />
                                <Column field="year" header="Year" />
                                {/* <Column field="createdBy" header="Created By" />
                                <Column field="createdDate" header="Created Date" /> */}
                                <Column body={this.actionTemplate} header="Action" />
                            </DataTable>

                               

                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(HolidayMaster);